import React, { useState } from 'react';

import DepositsApi from '../../../Api/CRM/Modules/DepositsApi';
import GetDepositDetailsResponse from '../../../Api/CRM/Responses/DepositDetailsResponse';
import { formatDateStringWithTimezone } from '../../../utils/formatters';
import ProtectedLink from '../../elements/ProtectedLink';
import Card from '../../elements/common/Card';
import ColoredStatus from '../../elements/common/ColoredStatus';
import Row, { TableDetailsBody } from '../../elements/common/TableDetailsRow';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';

import { PERMISSION } from 'crm/helpers/Permissions';

function DepositShow() {
    const { id } = useNumberParams();
    const [deposit, setDeposit] = useState<GetDepositDetailsResponse>({} as GetDepositDetailsResponse);

    useOnce(() => DepositsApi.getDepositDetails(id).then(setDeposit));

    const paymentLogs = deposit.payment_logs?.map((log) => (
        <TableDetailsBody key={log.id}>
            <Row label="Type">
                <ColoredStatus status={log.type} />
            </Row>
            <Row label="Message">{log.message}</Row>
            <Row label="Data">
                <code>{log.data}</code>
            </Row>
        </TableDetailsBody>
    ));

    return (
        <>
            <Card title="Deposit details">
                <TableDetailsBody>
                    <Row label="Token">{deposit.token}</Row>
                    <Row label="Email">
                        <ProtectedLink
                            url={`/users/${deposit.user_id}`}
                            value={deposit.email}
                            permissions={[PERMISSION.VIEW_USER]}
                        />
                    </Row>
                    <Row label="Name">{deposit.name}</Row>
                    <Row label="Surname">{deposit.surname}</Row>
                    <Row label="Phone">{deposit.phone}</Row>
                    <Row label="Payment method">{deposit.payment_method_name}</Row>
                    <Row label="Amount">{deposit.amount_formatted}</Row>
                    <Row label="User fee">{deposit.user_fee_formatted}</Row>
                    <Row label="Cost">{deposit.cost_formatted}</Row>
                    <Row label="Transaction out ID">{deposit.transaction_out_id}</Row>
                    <Row label="IP address">{deposit.ip_address}</Row>
                    <Row label="Status">
                        <ColoredStatus status={deposit.status} colorset="deposits" />
                    </Row>
                    <Row label="Date confirmed">{formatDateStringWithTimezone(deposit.date_confirmed)}</Row>
                    <Row label="Created">{formatDateStringWithTimezone(deposit.created_at)}</Row>
                    <Row label="Data">
                        <code>{JSON.stringify(deposit.data)}</code>
                    </Row>
                </TableDetailsBody>
            </Card>
            {paymentLogs?.length ? <Card title="Payment log">{paymentLogs}</Card> : null}
        </>
    );
}

export default DepositShow;
